module.exports = __webpack_public_path__ + "img/石化行业结构示意图.be042a0b.jpg";